import React from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { Forgot } from "../../../api";
import { useTranslation } from "../../../../context/TranslationContext";

const ForgotStepNewPassword = ({ token, onComplete }) => {
  const {
    newPassword: newPasswordLabel,
    confirmPassword: confirmPasswordLabel,
    updatePassword: updateBtn,
    passwordUpdateSuccess,
    passwordUpdateError,
    newPasswordRequired,
    confirmPasswordRequired,
    passwordMin,
    passwordsNotMatch,
  } = useTranslation();

  const Step3Schema = Yup.object().shape({
    password: Yup.string().required(newPasswordRequired).min(6, passwordMin),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password"), null], passwordsNotMatch)
      .required(confirmPasswordRequired),
  });

  const handleSubmit = async (values, actions) => {
    try {
      const data = {
        password: values.password,
        token: token,
      };
      const response = await Forgot(data, 3);
      if (response.data.error) {
        toast.error(response.data.error);
      } else {
        toast.success(passwordUpdateSuccess);
        onComplete();
      }
    } catch (error) {
      toast.error(passwordUpdateError);
    } finally {
      actions.setSubmitting(false);
    }
  };

  return (
    <Formik
      initialValues={{ password: "", confirmPassword: "" }}
      validationSchema={Step3Schema}
      onSubmit={handleSubmit}
    >
      {(props) => (
        <form onSubmit={props.handleSubmit}>
          <div className="relative z-0 mb-6 w-full group">
            <input
              type="password"
              id="password"
              name="password"
              className="block rounded-md py-5 px-6 w-full text-[0.875rem] bg-transparent border border-[#dee9ed] appearance-none focus:outline-none focus:ring-0 focus:border-text-rezervation-form peer"
              placeholder=" "
              onChange={props.handleChange}
              onBlur={props.handleBlur}
              value={props.values.password}
            />
            <label
              htmlFor="password"
              className="peer-focus:font-medium absolute text-[0.875rem] text-[#A2B2B8] focus:text-text-rezervation-form duration-300 transform -translate-y-6 scale-75 top-3 bg-white px-3 left-4 z-10 origin-[0] peer-focus:left-4 peer-focus:text-text-rezervation-form peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:text-[0.875rem] peer-focus:-translate-y-6"
            >
              {newPasswordLabel}
            </label>
            {props.errors.password && props.touched.password && (
              <span className="text-xs text-red-500 mt-1">
                {props.errors.password}
              </span>
            )}
          </div>
          <div className="relative z-0 mb-6 w-full group">
            <input
              type="password"
              id="confirmPassword"
              name="confirmPassword"
              className="block rounded-md py-5 px-6 w-full text-[0.875rem] bg-transparent border border-[#dee9ed] appearance-none focus:outline-none focus:ring-0 focus:border-text-rezervation-form peer"
              placeholder=" "
              onChange={props.handleChange}
              onBlur={props.handleBlur}
              value={props.values.confirmPassword}
            />
            <label
              htmlFor="confirmPassword"
              className="peer-focus:font-medium absolute text-[0.875rem] text-[#A2B2B8] focus:text-text-rezervation-form duration-300 transform -translate-y-6 scale-75 top-3 bg-white px-3 left-4 z-10 origin-[0] peer-focus:left-4 peer-focus:text-text-rezervation-form peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:text-[0.875rem] peer-focus:-translate-y-6"
            >
              {confirmPasswordLabel}
            </label>
            {props.errors.confirmPassword && props.touched.confirmPassword && (
              <span className="text-xs text-red-500 mt-1">
                {props.errors.confirmPassword}
              </span>
            )}
          </div>
          <button
            disabled={props.isSubmitting || !props.isValid || !props.dirty}
            type="submit"
            className="w-full text-white px-8 py-4 duration-200 bg-product-type-color hover:opacity-90 font-medium rounded-lg text-sm disabled:opacity-60 mb-5"
          >
            {updateBtn}
          </button>
        </form>
      )}
    </Formik>
  );
};

export default ForgotStepNewPassword;
